import ResultAiIndex from '@/views/result/ai-literacy/index.vue';
import ResultAiStudent from '@/views/result/ai-literacy/student/index.vue';
import ResultAiTeacher from '@/views/result/ai-literacy/teacher/index.vue';
import ResultAiPrincipal from '@/views/result/ai-literacy/principal/index.vue';
import ResultAiParent from '@/views/result/ai-literacy/parent/index.vue';
import ResultStatusAI from '@/views/result/ai-literacy/teacher/StatusAI.vue';
import ResultAiSchoolStatus from '@/views/result/ai-literacy/principal/SchoolStatusAI.vue';

const routes = [ 
  {
    path: "/result/ai-literacy",
    component: ResultAiIndex, 
    children: [      
      {
        path: "student",
        name: "ResultAiStudent",
        component: ResultAiStudent,        
      },
      {
        path: "teacher",
        name: "ResultAiTeacher",
        component: ResultAiTeacher,        
      },
      {
        path: "principal",
        name: "ResultAiPrincipal",
        component: ResultAiPrincipal,        
      },
      {
        path: "parent",
        name: "ResultAiParent",
        component: ResultAiParent,        
      },
      {
        path: "status",
        name: "ResultStatusAI",
        component: ResultStatusAI,        
      },
      {
        path: "school-status",
        name: "ResultAiSchoolStatus",
        component: ResultAiSchoolStatus,        
      }
    ]
  },   
];

export default routes;